import React from 'react'
import './Aec.css'
import Input from '../../../../UIComponents/Input/Input'
import { TestReportRightSection } from '../TestReportRightSection'
import ReportFooter from '../ReportFooter'
import { saveReports } from '../../../../redux/actions/Diagnostics/diagnostics'
import { useDispatch,useSelector } from 'react-redux'
import { useState } from 'react'
import { updateReports } from '../../../../redux/actions/Diagnostics/diagnostics'


export const Aec = () => {
    const dispatch =  useDispatch()
    const indexValue = useSelector(state => state?.diagnosticsInvoiceSummary?.indexValue)
    const reportDataFields = useSelector(state => state?.diagnosticsInvoiceSummary?.getdiagnostic)
    const [ inputValue, setInputValue ] = useState("")

    const onInputChange = (e) => {
      const { value, name } = e.target;
      const filterData = reportDataFields?.testReport?.filter(item => item.test === 'AEC')
      let index = 0
      reportDataFields?.testReport?.map((item, i) => {
        if(item.test === 'AEC'){
          index = i
        }
        return item
      })
      const finalFilteredData = filterData[0]?.fields?.map(item => {
        if(item.particular === name){
          item.result = value
        }
        return item
      })
    filterData[0].fields =  finalFilteredData
    reportDataFields.testReport[index]  = filterData[0]
    setInputValue(reportDataFields?.testReport[index]?.fields)
    dispatch(updateReports(reportDataFields))
    }
   
    return (
        <div>
            <div className='aec-main'>
                <div className='aec-container'>
                    <div className='aec-grid-container'>
                        <div className='padd'>AEC</div>
                        <div className='padd'></div>
                        <div className='padd'>ABSOLUTE EOSINOPHIL COUNT</div>
                        <Input className='aptinputs' type="number" name="ABSOLUTE EOSINOPHIL COUNT" onChange={onInputChange} value={reportDataFields?.testReport?.[indexValue]?.fields?.[0]?.result} disabled={!reportDataFields.active} />
                        <div className='padd'>/cmm</div>
                        <div className='padd'>40-440</div>
                        <div className='padd'></div>
                        <span className='bil-border1'></span>
                    </div>
                </div>
                <div className='bgroup-right-sec'>
                    <TestReportRightSection />
                </div>
            </div>
            <br></br>
            <div className='ivf-footer'>
                <ReportFooter />
            </div>
        </div>
    )
}
